(() => {
  const secondarySelector = '.product-card__image--secondary';

  // Native lazy loading prepares nearby photos before hover. This guard only
  // prevents an unfinished or failed download from hiding the primary photo.
  const updateImageState = (image) => {
    if (!image.matches?.(secondarySelector)) return;

    const card = image.closest('[data-product-card-hover]');
    if (card) card.dataset.productCardHover = image.naturalWidth > 0 ? 'ready' : 'error';
  };

  // Capture also handles cards inserted later by filters and sliders.
  document.addEventListener('load', (event) => updateImageState(event.target), true);
  document.addEventListener('error', (event) => updateImageState(event.target), true);

  document.querySelectorAll(secondarySelector).forEach((image) => {
    if (image.complete) updateImageState(image);
  });
})();
